var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00021 10.941L10.6424 15.7621C10.7736 15.8277 10.8392 15.8605 10.908 15.8734C10.9689 15.8848 11.0315 15.8848 11.0924 15.8734C11.1612 15.8605 11.2268 15.8277 11.358 15.7621L21.0002 10.941M1.00021 15.941L10.6424 20.7621C10.7736 20.8277 10.8392 20.8605 10.908 20.8734C10.9689 20.8848 11.0315 20.8848 11.0924 20.8734C11.1612 20.8605 11.2268 20.8277 11.358 20.7621L21.0002 15.941M1.00021 5.94098L10.6424 1.11987C10.7736 1.05428 10.8392 1.02148 10.908 1.00857C10.9689 0.997142 11.0315 0.997142 11.0924 1.00857C11.1612 1.02148 11.2268 1.05428 11.358 1.11987L21.0002 5.94098L11.358 10.7621C11.2268 10.8277 11.1612 10.8605 11.0924 10.8734C11.0315 10.8848 10.9689 10.8848 10.908 10.8734C10.8392 10.8605 10.7736 10.8277 10.6424 10.7621L1.00021 5.94098Z",
    stroke: "#E9C6FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutApp);
export default __webpack_public_path__ + "static/media/about_app.f144ef38c35d77bcc1c01643fe90c8f8.svg";
export { ForwardRef as ReactComponent };